<template>
<b-overlay :show="show" rounded="sm">
  <b-container fluid class="bg-white">
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row class="mb-3">
      <b-col>
        <h3 tabindex="0">{{acao === 'visualizar' ? 'Visualizar Configuração da Conferência' : 'Configurar Conferência'}}</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">&nbsp;</b-col>
      <b-col sm="8">
        <b-row>
          <b-col sm="_">
            <b-row align-h="end">
              <b-button pill variant="success">1</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="center">
              <b-button pill variant="primary">2</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="start">
              <b-button pill variant="success">3</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="start">
              <b-button pill variant="success">4</b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col sm="12">
       <b-row>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Dados da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Datas da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Pós-Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="2">
            <b-row align-h="center">Texto Apresentação</b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-form @submit.stop.prevent="salvar">
      <b-row class="mb-2">
        <b-col>
          <h4 tabindex="0">Período de Inscrições:</h4>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="4">
          <b-form-group tabindex="0" label="Data de Início: *" for="inscricao_inicio">
            <b-form-input id="inscricao_inicio" 
                  v-model="inscricao_inicio" 
                  v-mask="'##/##/####'"
                  type="text"
                  class="form-control"
                  placeholder="Data de Início" 
                 :disabled="acao === 'visualizar' || (configurarConferencia && configurarConferencia.situacao === 'Em Execução')"/>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group tabindex="0" label="Data de Término: *" for="inscricao_termino">
            <b-form-input id="inscricao_termino"
                  v-model="inscricao_termino" 
                  v-mask="'##/##/####'"
                  type="text"
                  class="form-control"
                  placeholder="Data de Término" 
                  :disabled="acao === 'visualizar' || (configurarConferencia && configurarConferencia.situacao === 'Em Execução')"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row><b-col><hr/></b-col></b-row>
      <b-row class="mb-2">
        <b-col>
          <h4 tabindex="0">Período de Execução:</h4>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="4">
          <b-form-group tabindex="0" label="Data de Início: *" for="execucao_inicio">
            <b-form-input id="execucao_inicio" 
                v-model="execucao_inicio" 
                v-mask="'##/##/####'"
                type="text"
                class="form-control"
                placeholder="Data de Início" 
                :disabled="acao === 'visualizar'"/>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group tabindex="0" label="Data de Término: *" for="execucao_termino">
            <b-form-input id="execucao_termino" 
                v-model="execucao_termino" 
                v-mask="'##/##/####'"
                type="text"
                class="form-control"
                placeholder="Data de Término" 
                :disabled="acao === 'visualizar'"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-row no-gutters>
            <b-button @click="voltar">
              <i class="fa fa-arrow-left"/>&nbsp;&nbsp;Voltar
            </b-button>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row no-gutters align-h="end">
            <b-button type="submit" variant="primary">
              <i class="fa fa-floppy-o"/>&nbsp;&nbsp;{{acao === 'visualizar' ? 'Avançar' : 'Salvar e Avançar'}}
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <b-row>
      <b-col>&nbsp;</b-col>
    </b-row>
  </b-container>
</b-overlay>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import SessionStorage from '@/services/session-storage'
import moment from 'moment'

export default {
  data () {
    return {
      acao: this.$route.params.acao,
      inscricao_inicio: '',
      inscricao_termino: '',
      execucao_inicio: '',
      execucao_termino: '',
      show: false
    }
  },
  computed: {
    ...mapState({
      configurarConferencia: state => state.conferencia.configurarConferencia,
      conferencia: state => state.conferencia.conferencia,
      mensagemConferencia: state => state.conferencia.mensagem
    })
  },
  mounted () {
    this.$store.dispatch('setConferencia', {
      'conferencia_id': SessionStorage.get('conferencia_atual_id'),
      'conferencia_nome': SessionStorage.get('conferencia_atual_nome')
    })

    Vue.http.post('api/configurarConferencia/buscar', {conferencia_id: this.conferencia.conferencia_id}).then(response => {
      if (response.body.success && response.body.data.length > 0) {
        let configurarConferencia = response.body.data[0]
        
       // this.inscricao_inicio = configurarConferencia.id
        if(configurarConferencia.inscricao_inicio){
             this.inscricao_inicio = moment(configurarConferencia.inscricao_inicio).format("DD/MM/YYYY")
        }
        if(configurarConferencia.inscricao_termino){
             this.inscricao_termino = moment(configurarConferencia.inscricao_termino).format("DD/MM/YYYY")
        }
        if(configurarConferencia.execucao_inicio){
             this.execucao_inicio = moment(configurarConferencia.execucao_inicio).format("DD/MM/YYYY")
        }
        if(configurarConferencia.execucao_termino){
             this.execucao_termino = moment(configurarConferencia.execucao_termino).format("DD/MM/YYYY")
        }
        this.$store.dispatch('setConfigurarConferencia', configurarConferencia)
      }
    })

    if (this.mensagemConferencia) {
      this.sucesso(this.mensagemConferencia)
      this.$store.commit('setMensagemConferencia', null)
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    salvar () {


      if (!this.inscricao_inicio || !this.inscricao_termino || !this.execucao_inicio || !this.execucao_termino) {
        this.show = false
        this.erro('Todas as datas são de preenchimento obrigatório.')  
        return false    
      } 

      var data_inscricao_inicio = moment(this.inscricao_inicio, "DD/MM/YYYY");
      var data_inscricao_termino = moment(this.inscricao_termino, "DD/MM/YYYY");
      var data_execucao_inicio = moment(this.execucao_inicio, "DD/MM/YYYY");
      var data_execucao_termino = moment(this.execucao_termino, "DD/MM/YYYY");

      data_inscricao_inicio = moment(data_inscricao_inicio).format('YYYY-MM-DD')
      data_inscricao_termino = moment(data_inscricao_termino).format('YYYY-MM-DD')
      data_execucao_inicio = moment(data_execucao_inicio).format('YYYY-MM-DD')
      data_execucao_termino = moment(data_execucao_termino).format('YYYY-MM-DD')

      if (Date.parse(data_inscricao_inicio) > Date.parse(data_inscricao_termino)) {
        this.erro('Data de início de inscrição deve ser anterior da data de término.')
      } else if (Date.parse(data_execucao_inicio) > Date.parse(data_execucao_termino)) {
        this.erro('Data de início de execução deve ser anterior da data de término.')
      } else if (Date.parse(data_inscricao_inicio) > Date.parse(data_execucao_inicio)) {
        this.erro('Data de início de inscrição deve ser anterior à data de início de execução.')
      } else if (this.acao === 'visualizar') {
        this.navigate('/configurarConferencia/passo3/' + this.acao)
      } else {
        let dados = {
          id: this.configurarConferencia.id,
          inscricao_inicio: data_inscricao_inicio,
          inscricao_termino: data_inscricao_termino,
          execucao_inicio: data_execucao_inicio,
          execucao_termino: data_execucao_termino
        }
        this.show = true
        Vue.http.post('api/configurarConferencia/salvar2', dados).then(response => {
          this.show = false
          if (response.body.success) {
            this.$store.commit('setMensagemConferencia', 'Dados salvos com sucesso!')
            this.navigate('/configurarConferencia/passo3/' + this.$route.params.acao)
          }
        })
      }
    },
    voltar () {
      if (!this.configurarConferencia.situacao || this.configurarConferencia.situacao === 'Rascunho' || this.acao === 'visualizar' || this.acao === 'editar') {
        this.navigate('/configurarConferencia/passo1/' + this.acao)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Passo2.vue